var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMccRestaurant(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Restaurants",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8385",
    "data-name": "Rectangle 8385",
    width: 28,
    height: 28,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_35236",
    "data-name": "Group 35236",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35882",
    "data-name": "Path 35882",
    d: "M13.855,9.4,12.612,3.6a.707.707,0,0,0-.248-.419,1.185,1.185,0,0,0-.5-.166.718.718,0,0,0-.5.249c-.083.166-.166.248-.166.415V9.814h-.741l-.746-6.3c-.083-.165-.083-.248-.166-.331a.629.629,0,0,0-.414-.166.587.587,0,0,0-.5.5l-.746,6.3H7.141V3.762a1.171,1.171,0,0,0-.166-.5c-.082-.161-.248-.161-.411-.246a1.046,1.046,0,0,0-.5.085.457.457,0,0,0-.249.414l-1.326,5.8a2.822,2.822,0,0,0,0,1.658,2.576,2.576,0,0,0,.745,1.492,4.175,4.175,0,0,0,2.238,1.326V24.817h3.4V13.875a4.64,4.64,0,0,0,2.32-1.326,3.468,3.468,0,0,0,.663-1.493,3.712,3.712,0,0,0,0-1.658",
    fill: "#b3b5c4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35883",
    "data-name": "Path 35883",
    d: "M23.3,3.762a2.215,2.215,0,0,0-.415-.5c-.165-.161-.414-.161-.579-.246a1.623,1.623,0,0,0-.663.085A7.243,7.243,0,0,0,18.083,6a8.35,8.35,0,0,0-1.409,4.393v4.891a4.792,4.792,0,0,0,.166,1.077,3.674,3.674,0,0,0,.663.912,2.148,2.148,0,0,0,.912.58,2.288,2.288,0,0,0,1.077.249h.746v6.88h3.4V4.425c-.166-.248-.166-.414-.332-.663",
    fill: "#b3b5c4"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMccRestaurant);
export default __webpack_public_path__ + "static/media/mcc_restaurant.797cb24806de8a53ebb7ad0b296dc542.svg";
export { ForwardRef as ReactComponent };